import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  imports: [CommonModule, TranslateModule],
})
export class NotificationComponent implements OnInit {
  type!: string;
  message!: string;
  title!: string;

  constructor(private bsModalRef: BsModalRef) { }

  ngOnInit(): void { }

  close(value: boolean) {
    this.bsModalRef.onHide?.emit(value);
    this.bsModalRef.hide();
  }
}
